function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { RichTextDropDown } from '@shared/components/richTextDropDown';
import SpzaComponent from '@shared/components/spzaComponent';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { Constants } from '@shared/utils/constants';
import { OdataRawObjectAppType } from '@shared/Models';
import { getWindow, Checkbox, MessageBar, MessageBarType, Spinner, Text, mergeStyleSets } from '@fluentui/react';
import { getCountries, isAvailableInThisRegion } from '@shared/utils/checkoutUtils';
import { StepperNodeStatus } from './stepper';
import { logger } from '@src/logger';
import { MSuserErrorBanner } from '@appsource/components';
const contentStyles = mergeStyleSets({
    locationSelection: {
        marginBottom: '10px'
    }
});
export class BillingRegionDropdownComponent extends SpzaComponent {
    componentDidMount() {
        var _getWindow_location, _getWindow;
        const payload = {
            page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.BillingCountry
        };
        this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
        logger.info('', {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    getDefaultCountry() {
        const defaultCountry = {
            text: Constants.usFilterText,
            value: Constants.usCountryCode.toUpperCase()
        };
        const filtered = this.countryList.filter((c)=>c.value === this.props.config.billingCountryCode.toUpperCase());
        return filtered[0] || defaultCountry;
    }
    renderDropDownSelectionBlock() {
        const defaultItem = this.state.selectedCountry;
        return /*#__PURE__*/ _jsx(RichTextDropDown, {
            className: "dropdown",
            "data-bi-id": 'CountryDropdown',
            "data-bi-Name": 'Country Selection',
            options: this.countryList,
            value: defaultItem,
            searchEnabled: true,
            isDisabled: this.state.isPickerDisabled,
            onChangeHandle: (option)=>this.handleCountrySelectionChange(option),
            dropdownLabel: this.context.loc('Select_Billing_Location_Dropdown_Label', 'Billing country/region')
        });
    }
    handleCountrySelectionChange(country) {
        var _this = this;
        return _async_to_generator(function*() {
            if (_this.state.isPickerDisabled) {
                return;
            }
            _this.setState({
                selectedCountry: country,
                isCountryConfirmed: false,
                loading: true
            });
            try {
                yield _this.props.setBillingCountry(country.value);
                yield _this.props.fetchPricing(_this.props.app.entityId, _this.props.app.appType === OdataRawObjectAppType.private);
                let isAppAvailableInCountry = true;
                if (!isAvailableInThisRegion(_this.props.app)) {
                    _this.props.updateStepStatus(0, StepperNodeStatus.Failed);
                    isAppAvailableInCountry = false;
                    // Block user from advancing at this point
                    _this.props.disableNextButton(true);
                } else {
                    _this.setState({
                        isAppAvailableInCountry: true
                    });
                    _this.props.updateStepStatus(0, StepperNodeStatus.Active);
                    _this.props.disableNextButton(!_this.state.isCountryConfirmed);
                }
                _this.setState({
                    loading: false,
                    isAppAvailableInCountry
                });
            } catch (e) {
                _this.setState({
                    loading: false,
                    isAppAvailableInCountry: false
                });
            }
        })();
    }
    renderLocationSelection() {
        const { users: { tenantsDetails: { details: { tenantId } } } } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: contentStyles.locationSelection,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    block: true,
                    className: "ms-fontWeight-semibold ms-fontSize-16",
                    children: this.context.loc('Select_Billing_CountryOrRegion', 'Select your billing country or region')
                }),
                /*#__PURE__*/ _jsx(MSuserErrorBanner, {
                    context: this.context,
                    tenantId: tenantId
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-10",
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            block: true,
                            children: [
                                " ",
                                this.context.loc('Select_Billing_FirstAppSourcePurchase'),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Text, {
                            block: true,
                            children: [
                                " ",
                                this.context.loc('Select_Billing_LocationMustMatchBillingAddress')
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            block: true,
                            className: 'ms-fontWeight-semibold mt-12',
                            children: this.context.loc('Select_Billing_CannotBeChangedText', "The billing country or region can't be changed later")
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Text, {
                    block: true,
                    className: "ms-fontWeight-semibold dropdown-header",
                    children: this.context.loc('Select_Billing_Location_Search_Header', 'Billing country/region')
                }),
                this.renderDropDownSelectionBlock()
            ]
        });
    }
    renderImpl() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "select-billing-country-wrapper",
            children: [
                this.renderLocationSelection(),
                this.state.loading && /*#__PURE__*/ _jsx("div", {
                    className: "loadingContainer",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "loading",
                        children: /*#__PURE__*/ _jsx(Spinner, {
                            label: this.context.loc('Gallery_Loading', 'Loading...'),
                            ariaLive: "assertive",
                            labelPosition: "left"
                        })
                    })
                }),
                !this.state.loading && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        this.renderInfoBanner(),
                        this.renderConfirmationCheckBox()
                    ]
                })
            ]
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "instrument", void 0), _define_property(this, "countryList", getCountries()), _define_property(this, "handleOnChange", (ev, checked)=>{
            if (this.state.isAppAvailableInCountry) {
                const isCountryConfirmed = checked;
                this.props.disableNextButton(!isCountryConfirmed);
                this.setState({
                    isPickerDisabled: isCountryConfirmed,
                    isCountryConfirmed
                });
            }
        }), _define_property(this, "renderConfirmationCheckBox", ()=>{
            return /*#__PURE__*/ _jsx(Checkbox, {
                "data-bi-id": "userConfirmedCountry",
                "data-bi-name": "User country confirmation checkbox",
                className: 'mt-12',
                label: this.context.loc('Checkout_CountryCannotBeChanged', "I understand that this selection can't be changed in the future"),
                onChange: this.handleOnChange,
                checked: this.state.isCountryConfirmed,
                disabled: !this.state.isAppAvailableInCountry
            });
        }), _define_property(this, "renderInfoBanner", ()=>{
            const { items } = this.props.checkout;
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: this.state.isAppAvailableInCountry ? /*#__PURE__*/ _jsx(MessageBar, {
                    className: 'not-available-info',
                    children: this.context.loc('Checkout_AppSourceMayNotSupport', "If your country isn't listed, AppSource purchase may not be supported in your region.")
                }) : /*#__PURE__*/ _jsx(MessageBar, {
                    className: 'not-available-info',
                    messageBarType: MessageBarType.severeWarning,
                    children: this.context.locParams('Select_Billing_Location_AppNotAllowed', [
                        items[0].title
                    ], `The offer “${items[0].title}” is not available for purchase in the selected country.`)
                })
            });
        });
        const { activeCustomer } = this.props.checkout;
        this.instrument = SpzaInstrumentService.getProvider();
        this.state = {
            loading: false,
            selectedCountry: this.getDefaultCountry(),
            isPickerDisabled: !!(activeCustomer === null || activeCustomer === void 0 ? void 0 : activeCustomer.address),
            isCountryConfirmed: !!(activeCustomer === null || activeCustomer === void 0 ? void 0 : activeCustomer.address),
            isAppAvailableInCountry: isAvailableInThisRegion(this.props.app)
        };
        this.props.disableNextButton(!this.state.isAppAvailableInCountry || !this.state.isCountryConfirmed);
    }
}
BillingRegionDropdownComponent.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
